import { useContext, useEffect } from 'react';

import { MenuItem, Select } from '@mui/material';
import { format } from 'date-fns';
import { enUS, es, ja, pt } from 'date-fns/locale';
import styled from 'styled-components';

import { DashboardContext } from '../../context/DashboardContext';

const SessionSelect = styled(Select)`
    width: 240px;
    height: 32px;
    margin-right: 24px;
`;

let { language } = window.navigator;

if (language.length > 2) {
    language = language.substr(0, 2);
}

const languageDateModules = {
    en: {
        locale: enUS,
        formatString: 'MM/dd/yyyy'
    },
    es: {
        locale: es,
        formatString: 'dd/MM/yyyy'
    },
    ja: {
        locale: ja,
        formatString: 'yyyy年MM月dd日'
    },
    pt: {
        locale: pt,
        formatString: 'dd/MM/yyyy'
    }
};
const languageDateModule = languageDateModules[language] ?? languageDateModules.en;
const { formatString, locale } = languageDateModule;

const DashboardSessionSelect: React.FC = () => {
    const { sessions, selectedSessionUuid, setSelectedSessionUuid } = useContext(DashboardContext);
    const handleSessionChange = (event) => {
        setSelectedSessionUuid(event.target.value as string);
    };

    useEffect(() => {
        if (!sessions.length) return;
        if (!selectedSessionUuid) {
            setSelectedSessionUuid(sessions[0].session_id);
        }
    }, [selectedSessionUuid, sessions, setSelectedSessionUuid]);
    return (
        <SessionSelect
            id='dashboard-session-select'
            value={selectedSessionUuid || ''}
            onChange={handleSessionChange}
        >
            {sessions.map((session, index) => {
                const startTimeDate = new Date(session.start_time);
                const dateString = `${format(startTimeDate, formatString, { locale })} - ${format(startTimeDate, 'eeee', { locale })}`;
                return (
                    <MenuItem value={session.session_id} key={index}>
                        {dateString}
                    </MenuItem>
                );
            })}
        </SessionSelect>
    );
};

export default DashboardSessionSelect;
